import type React from 'react';
import Box from '@mui/material/Box';
import { SectionToolbarAddMenu } from './SectionToolbarAddMenu';
import { useEffectivePageSize } from 'hooks/useEffectivePageSize';

interface SectionsBottomToolbarProps {
  sectionId: string;
}
export function SectionsBottomToolbar({ sectionId }: SectionsBottomToolbarProps) {
  const canvasWidth = useEffectivePageSize().width;

  return (
    <>
      <Box className="section-bottombar-wrapper" style={{ '--canvas-width': `${canvasWidth}px` } as React.CSSProperties}>
        <SectionToolbarAddMenu sectionId={sectionId} />
      </Box>
    </>
  );
}
